import { FC, useContext, useMemo } from 'react'
import Image from 'next/image'
import { Button, ELanguage } from '@microfrontends/react-components'
import AppContext from '../../../../context/AppContext'
import { createSlug } from '../../../../util/slug'
import { IEvent } from '../../assets/types'
import { Countdown } from './CountDown'
import { STButton, STContainer, STContent, STImage, STSubTitle } from './styles'
import { EDevice } from '../../../../containers/MainLayout'

interface IEventHotItemProps {
	event: IEvent
	utm?: string
}

export const EventHotItem: FC<IEventHotItemProps> = ({ event, utm }) => {
	const { languageCode, t, breakpoint } = useContext(AppContext)
	const isMobile =
		breakpoint === EDevice.MOBILE || breakpoint === EDevice.TABLET

	const eventDetailUrl = useMemo(() => {
		return `${t('/event/')}${createSlug(event.titleEvent)}-${event.eventId}?${utm || ''}`
	}, [languageCode])

	return (
		<STContainer isMobile={isMobile}>
			<STImage>
				<div>
					<Image
						alt={event.titleEvent}
						src={event.thumbnail || ''}
						layout='fill'
					/>
				</div>
			</STImage>

			<STContent>
				<STSubTitle href={eventDetailUrl}>
					{event.titleEvent}
				</STSubTitle>
				<Countdown event={event} />
				<STButton href={eventDetailUrl}>
					<Button type='primary' style={{ width: '100%' }}>
						{t('View detail')}
					</Button>
				</STButton>
			</STContent>
		</STContainer>
	)
}
